import { render, staticRenderFns } from "./NewSimLog.vue?vue&type=template&id=62c0afda&scoped=true&"
import script from "./NewSimLog.vue?vue&type=script&lang=js&"
export * from "./NewSimLog.vue?vue&type=script&lang=js&"
import style0 from "./NewSimLog.vue?vue&type=style&index=0&id=62c0afda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0afda",
  null
  
)

export default component.exports